(() => {
  if (window.bundleAffirmReady) return;
  window.bundleAffirmReady = true;

  const done = (root) => {
    root.classList.remove('bundle-affirm--loading');
    root.removeAttribute('aria-busy');
  };

  const hide = (root) => {
    root.classList.add('bundle-affirm--unavailable');
    done(root);
  };

  const sync = (root, source) => {
    const price = source.querySelector('.affirm-ala-price');
    if (!price) {
      if (source.textContent.trim()) hide(root);
      return;
    }
    root.classList.remove('bundle-affirm--unavailable');
    done(root);
    root.querySelectorAll('[data-bundle-affirm-monthly]').forEach((el) => (el.textContent = price.textContent.trim()));
  };

  const openModal = (event) => {
    const trigger = event.target.closest('.bundle-affirm__text a, [data-bundle-affirm-modal]');
    if (!trigger || typeof affirm !== 'object') return;
    event.preventDefault();
    const source = trigger.closest('.bundle-affirm')?.querySelector('.bundle-affirm__source');
    const amount = Number(source?.dataset.amount) || 0;
    affirm.ui.ready(() => affirm.ui.openModal({ amount, pageType: 'product' }));
  };

  const init = () => {
    document.querySelectorAll('.bundle-affirm').forEach((root) => {
      const source = root.querySelector('.bundle-affirm__source');
      if (!source) return;
      sync(root, source);
      new MutationObserver(() => sync(root, source)).observe(source, { childList: true, subtree: true, characterData: true });

      const hideIfEmpty = () => !source.querySelector('.affirm-ala-price') && hide(root);
      const check = () => {
        if (typeof affirm !== 'object') return hideIfEmpty();
        affirm.ui.ready(() => setTimeout(hideIfEmpty, 3000));
        setTimeout(hideIfEmpty, 5000);
      };
      if (document.readyState === 'complete') check();
      else window.addEventListener('load', check, { once: true });
    });
    document.addEventListener('click', openModal);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
